/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_AcceptInputs */

const en_consent_accept = /** @type {(inputs: Consent_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept analytics`)
};

/**
* | output |
* | --- |
* | "Accept analytics" |
*
* @param {Consent_AcceptInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const consent_accept = /** @type {((inputs?: Consent_AcceptInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_AcceptInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_consent_accept(inputs)
});